import { JumpstartSpinCommand } from "slotworks/commands/comms/jumpstart-spin-command";
import Components from "slotworks/components/components";
import RecoverFreespinsMode from "slotworks/state-machine/standard/states/recover-freespins-mode";
import Parallel from "slotworks/utils/contracts/parallel";

export default class RecoverFreespins extends RecoverFreespinsMode {

    public complete() {
        new Parallel([
            () => JumpstartSpinCommand(),
            () => Components.alert.recover("rec.fre")
        ]).then(() => super.complete());
    }
}
